"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _ErvNestedTiles = _interopRequireDefault(require("../../src/common/components/DrupalTiles/ErvNestedTiles.scss"));

var _DrupalTiles2 = _interopRequireDefault(require("../../src/common/components/DrupalTiles/DrupalTiles"));

var _cssConstants = _interopRequireDefault(require("./cssConstants.js"));

var _Constants = require("../../src/common/constants/Constants");

var _FormatSize = _interopRequireDefault(require("@material-ui/icons/FormatSize"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../src/helpers/DeviceInfoHelper"));

var _InvertColors = _interopRequireDefault(require("@material-ui/icons/InvertColors"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var FlippingTiles = /*#__PURE__*/function (_DrupalTiles) {
  (0, _inherits2["default"])(FlippingTiles, _DrupalTiles);

  var _super = _createSuper(FlippingTiles);

  function FlippingTiles() {
    (0, _classCallCheck2["default"])(this, FlippingTiles);
    return _super.apply(this, arguments);
  }

  return FlippingTiles;
}(_DrupalTiles2["default"]);

var _default = FlippingTiles;
exports["default"] = _default;